module.exports = __webpack_public_path__ + "static/media/Vans-Multicolor-Old-Skool-Sneaker-Lyst_thumb.ac35e22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Vans-Multicolor-Old-Skool-Sneaker-Lyst_thumb.png
// module id = 313
// module chunks = 0